import React, { useEffect, useState } from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module';
import _ from 'lodash';

import moment from 'moment';
import RateCardDistanceActionComponent from './rate-card-distance-action.component';
import TaxonomyDetailComponent from './taxonomy-details.component';

export default function ModalRateCardRuleComponent({ pinCodes, categories, Close,
    variants, productTypes, products, addTaxonomyRow, removeTaxonomy, handleTaxonomyFormChange, taxonomy, distances, handleItemSubmit, selectMobility, onInnerBasicFormChange }: any) {
    const [selectDisUnit, setSelectDisUnit] = useState<any>()
    const [isOpenDis, setIsOpenDis] = useState(false);

    useEffect(() => {
        if (selectMobility?.DistanceUnitId) {
            const selectedDistanceUnit = _.find(
                distances,
                (item) => String(item.Id) === selectMobility?.DistanceUnitId
            );

            setSelectDisUnit(selectedDistanceUnit)
        }

    }, [selectMobility])

    const distanceBaseMax = Number(selectMobility?.MaximumDistance)
    const distanceIncrement = Number(selectMobility?.DistanceIncrement)
    const distanceChargePerIncrement = Number(selectMobility?.DistanceIncrementCharge)

    // Toggle function
    const openDis = () => {
        setIsOpenDis((prev) => !prev);
    };


    const domainDataList = [
        {
            id: 10,
            name: "Roadside Assistance (RSA)",
            Code: "Roadside Assistance - ONDC:TRV12"
        },
        {
            id: 20,
            name: "Pickup and Drop (PUD)",
            Code: "PUD - ONDC:TRV12"
        },
        {
            id: 30,
            name: "Ride Hailing",
            Code: "Ride Hailing - ONDC:TRV10"
        },
        {
            id: 40,
            name: "Ticket(Unreserved)/Intracity mobility",
            Code: "Ticket(Unreserved)/Intracity mobility - ONDC:TRV11"
        }
    ]


    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <div className="text-xl font-bold mb-4 text-center">Add RateCard Rule</div>
            <div className='border'>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Basic Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'> please provide the Basic  Details.</div>
                    <div className="grid grid-cols-3 gap-4">

                        <InputContainer
                            label="Name"
                            name="Name"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'Name'

                                )
                            }}
                            type="text"
                            value={selectMobility?.Name}
                        />

                        <InputContainer
                            label="Domain"
                            labelField="name"
                            list={domainDataList}

                            onValueChange={(event: any, newValue: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'EdgeDBNDomainCode'

                                )
                            }}
                            optionName="Choose Domain"
                            type="select"
                            value={selectMobility?.EdgeDBNDomainCode}
                            valueField="name"
                        />
                        <InputContainer
                            isDisabled={!selectMobility?.EdgeDBNDomainCode}
                            label="RateCard Type"
                            labelField="Name"
                            list={categories.filter(
                                (v: any) => v.ParentCategoryName == selectMobility?.EdgeDBNDomainCode
                            )}
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'RateCardType'

                                )
                            }}
                            optionName='Choose RateCard Type'
                            type="select"
                            value={selectMobility?.RateCardType}
                            valueField="Name"
                        />
                        <InputContainer
                            label="Always Enabled"
                            name="IsAlwaysEnabled"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event,
                                    'IsAlwaysEnabled'

                                )
                            }}
                            type="checkbox"
                            value={selectMobility?.IsAlwaysEnabled}
                        />
                        {!selectMobility?.IsAlwaysEnabled ? <>
                            <InputContainer
                                label="Start Date"
                                name="StartDateUtc"
                                isDateTimePicker={true}
                                onValueChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        moment(event.target.value).utc().format('YYYY-MM-DDTHH:mm'),
                                        'StartDateUtc'

                                    )
                                }}
                                type="date"
                                value={selectMobility?.StartDateUtc}
                            />

                            <InputContainer
                                label="End Date"
                                name="EndDateUtc"
                                isDateTimePicker={true}
                                onValueChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        moment(event.target.value).utc().format('YYYY-MM-DDTHH:mm'),
                                        'EndDateUtc'

                                    )
                                }}
                                type="date"
                                value={selectMobility?.EndDateUtc}
                            />
                        </> : <></>}
                        <InputContainer
                            label="Active"
                            name="IsActive"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event,
                                    'IsActive'

                                )
                            }}
                            type="checkbox"
                            value={selectMobility?.IsActive}
                        />


                    </div>

                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='font-semibold line-clamp-2 mb-2 text-slate-800'>Servicability check Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>
                        If you want to enable this rate card for a specific pincode, just add the pincode.
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                        <InputContainer
                            label="PIN CODE"
                            labelField="Code"
                            list={pinCodes}
                            onValueChange={(newValue: any) => {
                                const pinCodeData: any = newValue.map((option: any) => option?.value || '')
                                onInnerBasicFormChange(
                                    pinCodeData,
                                    'PinCode'

                                )
                            }}
                            type="multiselect"
                            valueField="Code"
                            value={selectMobility?.PinCode}
                        />


                    </div>
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Distance Basic Charges Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>
                        If you want to include distance charges, please provide the minimum distance, maximum distance, and increment distance. The charges will increase based on each increment distance
                    </div>
                    <div className="grid grid-cols-5 gap-4">
                        <InputContainer
                            label="Unit"
                            labelField="SystemKeyword"
                            list={distances}

                            onValueChange={(event: any) => {

                                onInnerBasicFormChange(
                                    event.target.value,
                                    'DistanceUnitId'

                                )
                            }}
                            optionName='Choose Unit'
                            type="select"
                            value={selectMobility?.DistanceUnitId}
                            valueField="Id"
                        />

                        <InputContainer
                            label="Minimun Distance"
                            name="MinimunDistance"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'MinimunDistance'

                                )
                            }}
                            type="number"
                            value={selectMobility?.MinimunDistance}
                        />
                        <InputContainer
                            label="Maximum Distance"
                            name="MaximumDistance"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'MaximumDistance'

                                )
                            }}
                            type="number"
                            value={selectMobility?.MaximumDistance}
                        />

                        <InputContainer
                            label="Distance Increment"
                            name="DistanceIncrement"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'DistanceIncrement'

                                )
                            }}
                            type="number"
                            value={selectMobility?.DistanceIncrement}
                        />
                        <InputContainer
                            label="Increment Charge"
                            name="DistanceIncrementCharge"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'DistanceIncrementCharge'

                                )
                            }}
                            type="number"
                            value={selectMobility?.DistanceIncrementCharge}
                        /> 
                        <InputContainer
                            label="Is Inlcude Store As OriginLocation"
                            name="IsInlcudeStoreAsOriginLocation"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event,
                                    'IsInlcudeStoreAsOriginLocation'

                                )
                            }}
                            type="checkbox"
                            value={selectMobility?.IsInlcudeStoreAsOriginLocation}
                        />
                        
                    </div>
                    <div className='flex justify-end items-center w-full'>
                        <button
                            disabled={!selectMobility?.DistanceIncrementCharge}
                            title={`${!selectMobility?.DistanceIncrementCharge ? "Fill all the Inputs" : "calculate given value"}`}
                            className={`px-2 text-xs ${!selectMobility?.DistanceIncrementCharge ? "text-blue-600 opacity-50" : "text-blue-600"}  underline font-medium`}
                            onClick={openDis}
                        >
                            Action
                        </button>
                    </div>
                    {isOpenDis && (
                        <div>

                            <RateCardDistanceActionComponent
                                selectDisUnit={selectDisUnit?.SystemKeyword}
                                distanceBaseMax={distanceBaseMax}
                                distanceIncrement={distanceIncrement}
                                distanceChargePerIncrement={distanceChargePerIncrement}
                            />

                        </div>)}
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Service Charges Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>
                        If you want to include Service Charges Details.
                    </div>
                    <TaxonomyDetailComponent
                        taxonomy={taxonomy}
                        handleTaxonomyFormChange={handleTaxonomyFormChange}
                        removeTaxonomy={removeTaxonomy}
                        addTaxonomyRow={addTaxonomyRow}
                        products={products}
                        productTypes={productTypes}
                        variants={variants}
                        selectMobility={selectMobility}
                        distances={distances}

                    />
                </div>




            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-primary text-light rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-primary text-light rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}